export default __webpack_public_path__ + "static/compareItemImg4-73bd7cad7e086268f86ab3910479c324.png";